import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetUrl } from "../BaseUrl";
import { toast } from "react-hot-toast";

// export const handleGetUserFavourites = createAsyncThunk(
//   "favourite/handleGetUserFavourites",
//   async ({ token }, { rejectWithValue }) => {
//     const response = await GetUrl(`favourite`, {
//       headers: {
//         Authorization: token,
//       },
//     })
//       .then((res) => {
//         return res.data;
//       })
//       .catch((err) => {
//         // toast.error(err?.response?.data?.message);
//         return rejectWithValue(err?.response?.data);
//       });
//     return response;
//   }
// );

export const handleGetUserFavourites = createAsyncThunk(
  "favourite/handleGetUserFavourites",
  async ({ token }, { rejectWithValue }) => {
    // ✅ Token check add karein
    if (!token) {
      return rejectWithValue({ 
        silent: true, 
        message: "User not authenticated" 
      });
    }

    try {
      const res = await GetUrl(`favourite`, {
        headers: {
          Authorization: token,
        },
      });
      return res.data;
    } catch (err) {
      // Silent fail for 401 errors
      if (err?.response?.status === 401) {
        return rejectWithValue({ silent: true });
      }
      return rejectWithValue(err?.response?.data);
    }
  }
);


// export const handleGetUserFavourites = createAsyncThunk(
//   "favourite/handleGetUserFavourites",
//   async ({ token }, { rejectWithValue }) => {
//     if (!token) {
//       return rejectWithValue({ silent: true });
//     }

//     try {
//       const res = await GetUrl("favourite", {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       return res.data;
//     } catch (err) {
//       if (err?.response?.status !== 401) {
//         // toast.error(err?.response?.data?.message);
//       }
//       return rejectWithValue(err?.response?.data);
//     }
//   }
// );


export const handleAddProductToFavourites = createAsyncThunk(
  "features/handleAddProductToFavourites",
  async ({ signal, token, id }, { rejectWithValue }) => {
    signal.current = new AbortController();

    const response = await GetUrl(`/favourite/add/${id}`, {
      signal: signal.current.signal,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        // toast.error(err?.response?.data?.message);
        return rejectWithValue(err?.response?.data);
      });
    return response;
  }
);

export const handleRemoveProductToFavourites = createAsyncThunk(
  "features/handleRemoveProductToFavourites",
  async ({ signal, token, id }, { rejectWithValue }) => {
    signal.current = new AbortController();

    const response = await GetUrl(`/favourite/remove/${id}`, {
      signal: signal.current.signal,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        return rejectWithValue(err?.response?.data);
      });
    return response;
  }
);

const initialState = {
  loading: false,
  success: false,
  error: null,
  favourites: [],
};

const FavouriteSlice = createSlice({
  name: "favourite",
  initialState,
  reducers: {
    updateFavouriteStatus(state, { payload }) {
      const { id, isFavourite } = payload;
      state.favourites = state.favourites.map((product) =>
        product._id === id ? { ...product, isFavourite } : product
      );
    },
  },
  extraReducers: (builder) => {
    // get users favourites
    builder.addCase(handleGetUserFavourites.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
      state.favourites = [];
    });
    builder.addCase(handleGetUserFavourites.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = true;
      if (payload.status === "fail") {
        state.error = payload;
        state.favourites = [];
      } else {
        state.error = null;
        state.favourites = payload?.favourites;
      }
    });
    builder.addCase(handleGetUserFavourites.rejected, (state, action) => {
      // ✅ Silent error ko ignore karein
      if (action.payload?.silent) {
        state.loading = false;
        state.success = false;
        state.error = null; // No error set
        state.favourites = [];
        return;
      }
      
      state.loading = false;
      state.success = false;
      state.error = action.error;
      state.favourites = [];
    });
    // add favourties
    builder.addCase(handleAddProductToFavourites.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(handleAddProductToFavourites.fulfilled, (state, {}) => {
      state.loading = false;
      state.success = true;
      state.error = null;
    });
    builder.addCase(
      handleAddProductToFavourites.rejected,
      (state, { error }) => {
        state.loading = false;
        state.success = false;
        state.error = error;
      }
    );
    // remove favourties
    builder.addCase(handleRemoveProductToFavourites.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(handleRemoveProductToFavourites.fulfilled, (state, {}) => {
      state.loading = false;
      state.success = true;
      state.error = null;
    });
    builder.addCase(
      handleRemoveProductToFavourites.rejected,
      (state, { error }) => {
        state.loading = false;
        state.success = false;
        state.error = error;
      }
    );
  },
});

export const { updateFavouriteStatus } = FavouriteSlice.actions;

export default FavouriteSlice.reducer;
